import { API_URL } from "../constants/constants"

export const shopOrder = async (sessionToken, boxes, totalPrice) => {
  try {
    const response = await fetch(`${API_URL}/shop/boxes/order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
      },
      body: JSON.stringify({ boxes: boxes, total_price: totalPrice }),
    })

    return await response.json()
  } catch (error) {
    console.error("Error fetching boxes:", error)
  }
}

export const shopDeleteOrder = async (sessionToken, orderId) => {
  try {
    const response = await fetch(
      `${API_URL}/shop/boxes/delete-order/${orderId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
        },
        body: JSON.stringify({}),
      },
    )

    return await response.json()
  } catch (error) {
    console.error("Error delete order:", error)
  }
}
